module.exports = __webpack_public_path__ + "bo.svg?b42109acd165709aee8fb96d752f6480";